<template>
  <div class="cbg-layout">
    <div class="cbg-layout__bg">
      <img class="cbg-layout__bg-img" src="@/assets/images/bg.webp" alt="Stadium">
    </div>
    <ModalWrapper />
  </div>
</template>

<script>
import ModalWrapper from "@/components/parts/ModalWrapper.vue";
export default {
  name: 'ModalLayout',
  components: {
    ModalWrapper
  },
}
</script>